import { EntityModalForm } from "./CRUDs/abstracts/mixins/EntityModalForm";
import errors from "./errors";
import { Validator } from "./snippets/Validator";
import { Preloader } from "./Common/Preloader";

var Mustache = require('mustache');
import { SaveButton } from "./components/SaveButton";

export default {
    init() {
        this.showCreateSmsModal();
        this.createSms();
        this.saveSms();
        this.deleteSms();
        this.changeSmsText();
        this.ticketSettingsSave();
        this.generateApiToken();
        this.deleteApiTokens();
        this.plan();
        this.changeCard();
        this.changeRouteBySelect();
        this.saveSettings();
        this.sendTestNotify();
        this.initUsagePopup();
        this.initMissedPhone();
        this.createUpdateTax();
        this.changeDataPage();
        this.updateHistory();
    },
    showCreateSmsModal() {
        $('body').on('click', '#sms_modal_show', function(e) {
            e.preventDefault();
            $('#modal_create_sms input').val('');
            $('#modal_create_sms textarea').val('');
            $('#modal_create_sms').modal('show');
        });
    },
    createSms() {
        $('body').on('click', '#create_sms', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/settings/create-sms',
                data: ({
                    name: $('#sms_template_create').val(),
                    text: $('#message_text_create').val(),
                }),
                success: function (response) {
                    $.ajax({
                        type: 'GET',
                        url: '/settings/sms',
                        success: function (response) {
                            $('#sms_form').html(response);
                        },
                    });
                    $('#modal_create_sms').modal('hide');
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
            });
        });
    },
    saveSms() {
        $('body').on('click', '#save_sms', function(e) {
            e.preventDefault();
            if ($('#sms_id').val() !== '') {
                $.ajax({
                    type: 'POST',
                    url: '/settings/create-sms',
                    data: ({
                        id: $('#sms_id').val(),
                        name: $('#sms_template :selected').text(),
                        text: $('#message_text').val(),
                    }),
                    success: function (response) {
                    },
                    error: function (response) {
                        let err = response.responseJSON.errors;
                        errors.showAlerts(err);
                    },
                });
            }
        });
    },
    deleteSms() {
        $('body').on('click', '#delete_sms', function(e) {
            e.preventDefault();
            if ($('#sms_id').val() !== '') {
                $.ajax({
                    type: 'POST',
                    url: '/settings/delete-sms',
                    data: ({
                        id: $('#sms_template').val(),
                    }),
                    success: function (response) {
                        $('#sms_form').html(response);
                    },
                });
            }
        });
    },
    changeSmsText() {
        $('body').on('change', '#sms_template', function(e) {
            e.preventDefault();
            errors.hideAlerts();
            let id = $(this).val();
            $.ajax({
                type: 'GET',
                url: '/settings/get-sms-text',
                data: ({
                    id: id,
                }),
                success: function (response) {
                    $('#sms_id').val(id)
                    $('#message_text').val(response)
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
                complete: function (response) {

                },
            });
        });
    },
    ticketSettingsSave() {
        let $this = this;
        $('body').on('click', '#save_ticket', function(e) {
            e.preventDefault();
            errors.hideAlerts();

            let form = $('#ticket_form')[0];
            $.ajax({
                type: 'POST',
                url: '/settings/ticket',
                data: new FormData(form),
                processData: false,
                contentType: false,
                success: function (response) {
                    $('.messages').html('<div class="alert alert-success">'+ response.message +'</div>');
                    $this.previewTicket();
                    setTimeout(function () {
                        $('.messages .alert').css('margin-top', '0');
                    }, 500);
                },
                error: function (response) {
                    let err = response.responseJSON.errors;
                    errors.showAlerts(err);
                },
                complete: function (response) {
                    setTimeout(function () {
                        $('.messages .alert').css('margin-top', '-70px');
                    }, 4500);
                    setTimeout(function () {
                        $('.messages').html('');
                    }, 5000);
                },
            });
        });
    },
    previewTicket() {
        $.ajax({
            type: 'GET',
            url: '/settings/ticket',
            success: function (response) {
                $('#ticket_preview').html(response);
            },
        });
    },
    generateApiToken() {
        $('body').on('click', '#generate_token', function(e) {
            $('#generate_token').prop('disabled', true);
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/tokens/create',
                data: ({
                    token_name: 'pos_access'
                }),
                success: function (response) {
                    let token = response.token.split('|')[1];
                    $('#token').text(token);
                    $('#delete_tokens').prop('disabled', false);
                    let view = {api_token: token};
                    let template = $('#script_tmpl').html() + "\n</script>";
                    let script = Mustache.render(template, view);
                    $('#script').val(script);
                },
                error: function() {
                    $('#generate_token').prop('disabled', false);
                }
            });
        });
    },
    deleteApiTokens() {
        $('body').on('click', '#delete_tokens', function(e) {
            $('#delete_tokens').prop('disabled', true);
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/tokens/delete',
                success: function () {
                    $('#token').text('');
                    $('#script').val('');
                    $('#generate_token').prop('disabled', false);
                },
                error: function() {
                    $('#delete_tokens').prop('disabled', false);
                }
            });
        });

    },
    plan() {
        $('body').on('click', '#change-plan', function(e) {
            $('#plan-modal').modal('show');
        });

        $('body').on('click', '.select-subscription-plan', function(e) {
            $.ajax({
                type: 'POST',
                url: '/settings/change-billing-plan',
                data: ({
                    plan: $(this).data('plan'),
                }),
                success: function (response) {
                    window.location.replace('/dashboard')
                },
            });
        });
    },

    changeCard() {
        $('body').on('click', '#change-card', function(e) {
            $('#change-card-modal').modal('show');
        });
    },
    changeRouteBySelect() {
        $('select#routeSelectSettings').on('change', function(e) {
            var link = $("option:selected", this).val()
            location.href = link;
        })
    },

    saveSettings() {
        $('body').on('click', 'button.setting-save[data-save]', (e) => {
            let SaveBtn = new SaveButton();

            $.ajax({
                type: 'POST',
                url: '/settings',
                data: {
                    'organisation_id': $(e.target).data('organisation'),
                    'group': 'cockpit',
                    'settings': {
                        'call_forwarding_phone': $('input[name=call_forwarding_phone]').val(),
                        'call_recording': $('input[name=call_recording]').prop('checked'),
                        'email_in_html_format': $('input[name=email_in_html_format]').prop('checked'),
                        'cockpit_default_subject': $('input[name=cockpit_default_subject]').val()
                    }
                },
                beforeSend: () => {
                    SaveBtn.startLoading();
                },
                success: (response) => {
                    SaveBtn.stopLoading().then(() => {
                        SaveBtn.showSuccess();
                    });
                },
                error: (response) => {
                    SaveBtn.showError();
                }
            });
        });

        $('body').on('click', '#create-org-form .btn-info-save.edit', function(e) {
            e.preventDefault();

            $('form.basic-form').find('input, select').removeAttr('disabled');
            $(this).text('Save');
            $(this).removeClass('edit');
        });
        $('body').on('click', '#settings #create-org-form .btn-info-save:not(.edit)', (e) => {
            e.preventDefault();
            const org_id = $(e.currentTarget).data('org_id');
            const form = $(e.currentTarget).parents('form')[0];
            const data = new FormData(form);

            $.ajax({
                type: 'POST',
                url: `/save-organisation/${org_id}`,
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                beforeSend: () => {
                    $('.bb-preloader-container').show();
                },
                success: (response) => {
                    console.log(response);
                    if (response.view) {
                        $('.organisation-info-container').html(response.view);
                    }
                    $('.bb-preloader-container').hide();

                },
                error: (response) => {
                    console.log(response);
                    $('.bb-preloader-container').hide();

                }
            });
        });

        /*$('body').on('change', '#settings form.organisation-info-form #timezone', (e) => {
            const org_id = $(e.currentTarget).parents('form').data('org_id');
            $.ajax({
                type: 'POST',
                url: `/save-organisation/${org_id}`,
                data: {
                    'timezone': $(e.currentTarget).val()
                },
                success: (response) => {}
            });
        });*/
    },

    sendTestNotify(){
        $('#send-test-notify').on('click',()=>{
            $.ajax({
                type: 'POST',
                url: '/cockpit/send-test-notify',
                success: (response) => {
                    console.log(response)
                },
                error: (response) => {
                    console.log(response);
                }
            });
        })
    },

    initUsagePopup(){
        $('body').off('click', '.details_info')
        .on('click', '.details_info',  function(ev) {
            let targetId = $(ev.currentTarget).data('target')
            if(!targetId)
                return
            const detailsPopup = $('#'+targetId);
            if(detailsPopup.length){
                const rect = detailsPopup[0].getBoundingClientRect();
                //detailsPopup.css({top: `-${rect.height+10}px`, left: `0`, zIndex:'100'});
                //detailsPopup.addClass('visible');
                detailsPopup.addClass(['show','d-flex']);
            }
        });

        $('body').off('click', '.details-popup .standart-close-btn')
        .on('click', '.details-popup .standart-close-btn', function(ev) {
            const parents = $(ev.currentTarget).parents('.details-popup');
            if(!parents.length)
                return
            parents.removeClass(['show','d-flex'])
            parents.css({zIndex:''})
        });
    },

    initMissedPhone(){
        $('body').off('click', '#missed-phone-org-btno')
        .on('click', '#missed-phone-org-btn',  function(ev) {
            $.ajax({
                url: 'missed-phone',
                method: 'POST',
                dataType: 'json',
                success: function(response) {
                    if (response.success)
                        window.location.replace(window.location.origin+'/cockpit')
                },
            });
        })
    },

    createUpdateTax(){
        let SaveBtn = new SaveButton('#edit-tax-modal');
        $('body').off('click', '#edit-tax-modal #button-save-tax')
        .on('click', '#edit-tax-modal #button-save-tax', function(ev){
            let data = {
                title: $('#edit-tax-modal .tax_rate_form input[name="title"]').val(),
                percent: $('#edit-tax-modal .tax_rate_form input[name="percent"]').val()
            }
            if($(ev.target).attr('data-id')){
                data.id = $(ev.target).attr('data-id')
            }
            $.ajax({
                type: 'POST',
                url: '/settings/business/create-edit-tax',
                data:data,
                beforeSend: () => {
                    SaveBtn.startLoading();
                },
                success: (response) => {
                    if(response?.success){
                        SaveBtn.stopLoading().then(() => {
                            SaveBtn.showSuccess();
                        });
                        if(data.id){
                            let el = $(`.tax_rates .create-edit-tax[data-id="${data.id}"]`)
                            if(el){
                                el.parents('.tax-row').find('.title-tax').text(data.title)
                                el.attr('data-title', data.title)
                            }
                        }else if(response?.newId){
                            let template = $(`.tax_rates #tax-row-tmpl`).clone(true)
                            template.attr('id','')
                            template.removeClass('d-none')
                            template.find('.title-tax').text(data.title)
                            template.find('.percent').text(Number(data.percent).toFixed(2)+'%')
                            template.find('.create-edit-tax').attr('data-id', response.newId)
                                                            .attr('data-percent', data.percent)
                                                            .attr('data-title', data.title)
                            $('.tax_rates .tax_rates_list tbody').append(template)
                        }
                        setTimeout(()=> $('#edit-tax-modal').modal('hide'), 3000)
                    }else{
                        $('#edit-tax-modal .component-data-save .error-message').html('')
                        if(typeof response.error == 'object'){
                            let errorsArr = Object.values(response.error);
                            $('#edit-tax-modal .component-data-save .error-message').append(errorsArr.join('<br>'));
                        }else if(typeof response.error == 'string'){
                            $('#edit-tax-modal .component-data-save .error-message').text(response.error);
                        }
                        SaveBtn.stopLoading().then(() => {
                            SaveBtn.showError();
                        });
                    }
                },
                error: (response) => {
                    SaveBtn.showError();
                }
            });
        })

        $('body').off('click', '.tax_rates .create-edit-tax')
        .on('click', '.tax_rates .create-edit-tax', function(ev){
            if($(ev.target).data('id')){
                $('#edit-tax-modal .tax_rate_form input[name="title"]').val($(ev.target).data('title'))
                $('#edit-tax-modal .tax_rate_form input[name="percent"]').val($(ev.target).data('percent'))
                $('#edit-tax-modal .tax_rate_form input[name="percent"]').attr('disabled',true)
                $('#edit-tax-modal #button-save-tax').attr('data-id', $(ev.target).data('id'))
            }else{
                $('#edit-tax-modal .tax_rate_form input[name="percent"]').attr('disabled',false)
                $('#edit-tax-modal .tax_rate_form input[name="percent"]').val('')
                $('#edit-tax-modal .tax_rate_form input[name="title"]').val('')
                $('#edit-tax-modal #button-save-tax').attr('data-id', '')
            }
            $('#edit-tax-modal').modal('show');
        })

        $('body').off('input','#edit-tax-modal .tax_rate_form input[name="percent"]')
        .on('input', '#edit-tax-modal .tax_rate_form input[name="percent"]', function(ev){
            let value = $(ev.target).val()
            if (/[^0-9\.]*/.test(value))
                value = value.replace(/[^0-9\.]*/g, '')
            if (value.toString().match(/[.]/g)?.length > 1 || /\.\d{3,}/.test(value))
                value = value.substring(0, value.length - 1)
            if (Number(value) > 100 || /100\./.test(value)) {
                value = 100
            }
            $(ev.target).val(value)
        })
    },

    changeDataPage(){
        $('body').on('click', '#settings .change-page.active', (e) => {
            const type = $(e.currentTarget).parent().data('type');
            const year = $(e.currentTarget).parent().data('year');
            const next_page =  $(e.currentTarget).data('next_page');
            const preloader = new Preloader('data-tables');
            if (type) {
                $.ajax({
                    type:'POST',
                    url: `/settings/get-${type}`,
                    data: {
                        next_page: next_page,
                        year: year
                    },
                    beforeSend: ()=>{
                        preloader.open();
                    },
                    success:(response)=>{
                        $(`.data-container.${type}`).html(response);
                    },
                    error: (response)=> {
                        if (response.status == 405) {
                            $(e.currentTarget).removeClass('active');
                        }
                    },
                    complete: () => {
                        preloader.close();
                    }
                });
            }
        })
    },

    updateHistory(){
        $('body').on('change', '#settings .select-history-year', function(e) {
            e.preventDefault();
            const year = $(this).val();
            const preloader = new Preloader('data-tables');
            $.ajax({
                type:'POST',
                url: `/settings/get-payment-history`,
                data: {
                    next_page: 1,
                    year: year
                },
                beforeSend: () => {
                    preloader.open();
                },
                success:(response)=>{
                    $(`.data-container.payment-history`).html(response);
                },
                error: (response)=> {
                    if (response.status == 405) {
                        $(e.currentTarget).removeClass('active');
                    }
                },
                complete: () => {
                    preloader.close();
                }
            });
        });
        $('body').on('change', '#settings .select-usage-month', function(e) {
            e.preventDefault();
            const month = $(this).val();
            const preloader = new Preloader('data-tables');
            $.ajax({
                type:'POST',
                url: `/settings/get-usage-history`,
                data: {
                    next_page: 1,
                    year: month
                },
                beforeSend: () => {
                    preloader.open();
                },
                success:(response)=>{
                    $(`.data-container.usage-history`).html(response);
                },
                error: (response)=> {
                    if (response.status == 405) {
                        $(e.currentTarget).removeClass('active');
                    }
                },
                complete: () => {
                    preloader.close();
                }
            });
        });
        $('body').on('change', '#settings .select-monthly-bill-month', function(e) {
            e.preventDefault();
            const month = $(this).val();
            const preloader = new Preloader('data-tables');
            $.ajax({
                type:'POST',
                url: `/settings/get-monthly-bill`,
                data: {
                    next_page: 1,
                    year: month
                },
                beforeSend: () => {
                    preloader.open();
                },
                success:(response)=>{
                    $(`.data-container.monthly-bill`).html(response);
                },
                error: (response)=> {
                    if (response.status == 405) {
                        $(e.currentTarget).removeClass('active');
                    }
                },
                complete: () => {
                    preloader.close();
                }
            });
        });
    }
}
